<!--Self-Assessment Step Component-->
<div class="feedback-step">
  <div class="step-header">
    <h3>{{ stepData.categoryTitle }}</h3>
    <div class="overall-score" *ngIf="overAllScore">
      <span>Overall Score: {{ overAllScore | number: '1.2-2' }}</span>
    </div>
  </div>
  <form nz-form class="form" nzLayout="horizontal" [formGroup]="formGroup">
    <div>
      <nz-tabset [(nzSelectedIndex)]="selectedTabIndex">
        @for (tab of tabs; track tab; let i = $index) {
          <nz-tab [nzTitle]="tab.title">
            <ng-container *ngIf="i === selectedTabIndex">
              <div
                *ngIf="tab.key === 'teacher'"
                formArrayName="questionResponses">
                <div
                  *ngFor="
                    let questionItem of teacherQuestionsWithIndex;
                    let i = index;
                    trackBy: trackByQuestionId
                  "
                  class="question-item"
                  [formGroupName]="questionItem.index">
                  <div class="header-with-cta mb-16">
                    <div class="quetion-badge">
                      <span class="badge">Q{{ i + 1 }}</span>
                      <h3 class="title s-18">
                        {{ questionItem.question.question }}
                      </h3>
                    </div>
                  </div>

                  <nz-form-control
                    [nzErrorTip]="getQuestionErrorTip(questionItem.question.id)"
                    [nzValidateStatus]="
                      getQuestionValidationStatus(questionItem.question.id)
                    "
                    [nzHasFeedback]="true">
                    <div class="radio-wrapper">
                      <nz-radio-group
                        formControlName="ratingScale"
                        class="radio-group frequency-group"
                        [disabled]="stepData.isViewMode">
                        <span nz-radio [nzValue]="1" class="box-radio">
                          <span class="radio-label">Never</span>
                        </span>
                        <span nz-radio [nzValue]="2" class="box-radio">
                          <span class="radio-label">Sometimes</span>
                        </span>
                        <span nz-radio [nzValue]="3" class="box-radio">
                          <span class="radio-label">Often</span>
                        </span>
                        <span nz-radio [nzValue]="4" class="box-radio">
                          <span class="radio-label">Almost Always</span>
                        </span>
                      </nz-radio-group>
                    </div>
                  </nz-form-control>

                  <hr class="question-divider" />
                </div>
              </div>

              <div
                *ngIf="tab.key === 'student'"
                formArrayName="questionResponses">
                <div
                  *ngFor="
                    let questionItem of studentQuestionsWithIndex;
                    let i = index;
                    trackBy: trackByQuestionId
                  "
                  class="question-item"
                  [formGroupName]="questionItem.index">
                  <div class="header-with-cta mb-16">
                    <div class="quetion-badge">
                      <span class="badge">Q{{ i + 1 }}</span>
                      <h3 class="title s-18">
                        {{ questionItem.question.question }}
                      </h3>
                    </div>
                  </div>

                  <div
                    *ngIf="isTextQuestion(questionItem.question.id)"
                    class="text-input-container">
                    <nz-form-control
                      [nzErrorTip]="
                        getQuestionErrorTip(questionItem.question.id)
                      "
                      [nzValidateStatus]="
                        getQuestionValidationStatus(questionItem.question.id)
                      "
                      [nzHasFeedback]="true">
                      <input
                        [id]="questionItem.question.id"
                        formControlName="description"
                        nz-input
                        placeholder="Enter answer"
                        [disabled]="stepData.isViewMode" />
                    </nz-form-control>
                  </div>

                  <div
                    *ngIf="!isTextQuestion(questionItem.question.id)"
                    class="radio-wrapper">
                    <nz-form-control
                      [nzErrorTip]="
                        getQuestionErrorTip(questionItem.question.id)
                      "
                      [nzValidateStatus]="
                        getQuestionValidationStatus(questionItem.question.id)
                      "
                      [nzHasFeedback]="true">
                      <nz-radio-group
                        formControlName="ratingScale"
                        class="radio-group frequency-group"
                        [disabled]="stepData.isViewMode">
                        <span nz-radio [nzValue]="1" class="box-radio">
                          <span class="radio-label">Never</span>
                        </span>
                        <span nz-radio [nzValue]="2" class="box-radio">
                          <span class="radio-label">Sometimes</span>
                        </span>
                        <span nz-radio [nzValue]="3" class="box-radio">
                          <span class="radio-label">Often</span>
                        </span>
                        <span nz-radio [nzValue]="4" class="box-radio">
                          <span class="radio-label">Almost Always</span>
                        </span>
                      </nz-radio-group>
                    </nz-form-control>
                  </div>

                  <hr class="question-divider" />
                </div>
              </div>

              <div *ngIf="tab.key === 'both'" formArrayName="questionResponses">
                <nz-collapse
                  [nzBordered]="false"
                  [nzExpandIconPosition]="'end'">
                  <nz-collapse-panel
                    [nzActive]="sections[0].active"
                    [nzHeader]="sections[0].name"
                    (nzActiveChange)="onSectionChange(0, $event)"
                    [nzExtra]="extraTpl">
                    <div
                      *ngFor="
                        let questionItem of teacherQuestionsWithIndex;
                        let i = index;
                        trackBy: trackByQuestionId
                      "
                      class="question-item"
                      [formGroupName]="questionItem.index">
                      <div class="header-with-cta mb-16">
                        <div class="quetion-badge">
                          <span class="badge">Q{{ i + 1 }}</span>
                          <h3 class="title s-18">
                            {{ questionItem.question.question }}
                          </h3>
                        </div>
                      </div>

                      <nz-form-control
                        [nzErrorTip]="
                          getQuestionErrorTip(questionItem.question.id)
                        "
                        [nzValidateStatus]="
                          getQuestionValidationStatus(questionItem.question.id)
                        "
                        [nzHasFeedback]="true">
                        <div class="radio-wrapper">
                          <nz-radio-group
                            formControlName="ratingScale"
                            class="radio-group frequency-group"
                            [disabled]="stepData.isViewMode">
                            <span nz-radio [nzValue]="1" class="box-radio">
                              <span class="radio-label">Never</span>
                            </span>
                            <span nz-radio [nzValue]="2" class="box-radio">
                              <span class="radio-label">Sometimes</span>
                            </span>
                            <span nz-radio [nzValue]="3" class="box-radio">
                              <span class="radio-label">Often</span>
                            </span>
                            <span nz-radio [nzValue]="4" class="box-radio">
                              <span class="radio-label">Almost Always</span>
                            </span>
                          </nz-radio-group>
                        </div>
                      </nz-form-control>

                      <hr class="question-divider" />
                    </div>
                  </nz-collapse-panel>

                  <nz-collapse-panel
                    [nzActive]="sections[1].active"
                    [nzHeader]="sections[1].name"
                    (nzActiveChange)="onSectionChange(1, $event)"
                    [nzExtra]="extraTpl">
                    <div
                      *ngFor="
                        let questionItem of studentQuestionsWithIndex;
                        let i = index;
                        trackBy: trackByQuestionId
                      "
                      class="question-item"
                      [formGroupName]="questionItem.index">
                      <div class="header-with-cta mb-16">
                        <div class="quetion-badge">
                          <span class="badge">Q{{ i + 1 }}</span>
                          <h3 class="title s-18">
                            {{ questionItem.question.question }}
                          </h3>
                        </div>
                      </div>

                      <div
                        *ngIf="isTextQuestion(questionItem.question.id)"
                        class="text-input-container">
                        <nz-form-control
                          [nzErrorTip]="
                            getQuestionErrorTip(questionItem.question.id)
                          "
                          [nzValidateStatus]="
                            getQuestionValidationStatus(
                              questionItem.question.id
                            )
                          "
                          [nzHasFeedback]="true">
                          <input
                            formControlName="description"
                            nz-input
                            placeholder="Enter answer"
                            [disabled]="stepData.isViewMode" />
                        </nz-form-control>
                      </div>

                      <div
                        *ngIf="!isTextQuestion(questionItem.question.id)"
                        class="radio-wrapper">
                        <nz-form-control
                          [nzErrorTip]="
                            getQuestionErrorTip(questionItem.question.id)
                          "
                          [nzValidateStatus]="
                            getQuestionValidationStatus(
                              questionItem.question.id
                            )
                          "
                          [nzHasFeedback]="true">
                          <nz-radio-group
                            formControlName="ratingScale"
                            class="radio-group frequency-group"
                            [disabled]="stepData.isViewMode">
                            <span nz-radio [nzValue]="1" class="box-radio">
                              <span class="radio-label">Never</span>
                            </span>
                            <span nz-radio [nzValue]="2" class="box-radio">
                              <span class="radio-label">Sometimes</span>
                            </span>
                            <span nz-radio [nzValue]="3" class="box-radio">
                              <span class="radio-label">Often</span>
                            </span>
                            <span nz-radio [nzValue]="4" class="box-radio">
                              <span class="radio-label">Almost Always</span>
                            </span>
                          </nz-radio-group>
                        </nz-form-control>
                      </div>

                      <hr class="question-divider" />
                    </div>
                  </nz-collapse-panel>
                </nz-collapse>
              </div>
            </ng-container>
          </nz-tab>
        }
      </nz-tabset>
    </div>
  </form>
</div>

<ng-template #extraTpl>
  <svg-icon src="/assets/icon/icon-plus.svg" class="icon s-20"> </svg-icon>
  <svg-icon src="/assets/icon/icon-minus.svg" class="icon s-20"> </svg-icon>
</ng-template>
